import React, { useState } from 'react';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: 'What does CodeRidge focus on beyond traditional software delivery?',
      answer: 'We emphasize intelligent automation and LLM workflows, zero-trust oriented security, Cloud 3.0 operations on AWS and Azure, and 24/7 managed IT—so technology accelerates the business instead of acting as a bottleneck.'
    },
    {
      question: 'Do you offer a free infrastructure or security assessment?',
      answer: 'Yes. You can request a free infrastructure audit via our contact form. We use it to understand your stack, priorities, and constraints, then recommend practical next steps—whether cloud, security, automation, or operations.'
    },
    {
      question: 'How do you approach AI and automation in production?',
      answer: 'We start with high-friction workflows and clear KPIs, design retrieval and governance up front, integrate with your systems of record, and run structured evaluation before scaling. Guardrails, observability, and human handoffs are part of the default design—not afterthoughts.'
    },
    {
      question: 'What does “zero trust” mean in how you work with clients?',
      answer: 'Identity-first access, least privilege, logging and detection you can act on, and hardening aligned to how your teams actually work. We help prioritize controls that reduce real risk—not checkbox theater.'
    },
    {
      question: 'Which cloud platforms do you support?',
      answer: 'Primarily AWS and Azure, including hybrid connectivity, landing zones, migrations, Kubernetes where appropriate, FinOps practices, CI/CD, and observability. We align architecture to your compliance and latency requirements.'
    },
    {
      question: 'What is included in managed IT excellence?',
      answer: 'Monitoring and alerting, patching and change management, backup verification, service desk coordination, and reporting suited for both IT and business stakeholders—with clear escalation when incidents occur.'
    },
    {
      question: 'How long do projects or migrations typically take?',
      answer: 'It depends on scope: a focused audit or pilot automation may be weeks; cloud migrations and platform work are often phased over months. We propose waves with explicit success criteria and rollback thinking—not big-bang cutovers without validation.'
    },
    {
      question: 'Can you work alongside our internal IT or engineering team?',
      answer: 'Yes. We often operate as an extension of leadership—pairing with your staff for delivery, documentation, and runbooks so knowledge stays in your organization.'
    },
    {
      question: 'How do you price engagements?',
      answer: 'We use fixed-scope proposals, time and materials, or retained capacity for operations depending on the work. Proposals follow discovery so pricing maps to outcomes and risk, not vague estimates.'
    },
    {
      question: 'What industries do you serve?',
      answer: 'We work with organizations that depend on reliable systems—SaaS, education technology, healthcare-aligned workloads, e-commerce, and more. Patterns from cloud, security, and automation translate across sectors when outcomes and constraints are clear.'
    }
  ];

  const toggleFAQ = (index) => {
    // Accordion behavior: only one item open at a time
    // If clicking the same item, close it; otherwise, open the new one
    setOpenIndex(prevIndex => prevIndex === index ? null : index);
  };

  return (
    <section id="faq" className="faq-section">
      <div className="faq-background">
        <div className="faq-shape faq-shape-1"></div>
        <div className="faq-shape faq-shape-2"></div>
      </div>
      
      <div className="container">
        <div className="section-header">
          <span className="section-label">FAQ</span>
          <h2 className="section-title">Answers before you engage</h2>
          <p className="section-description">
            Automation, security, Cloud 3.0, managed operations, and how we engage—from audits to long-term partnership.
          </p>
        </div>

        <div className="faq-container">
          {faqs.map((faq, index) => (
            <div 
              key={index} 
              className={`faq-item ${openIndex === index ? 'active' : ''}`}
            >
              <button 
                className="faq-question"
                onClick={() => toggleFAQ(index)}
                aria-expanded={openIndex === index}
              >
                <span className="faq-question-text">{faq.question}</span>
                <svg 
                  className="faq-icon"
                  width="24" 
                  height="24" 
                  viewBox="0 0 24 24" 
                  fill="none"
                >
                  <path 
                    d="M6 9L12 15L18 9" 
                    stroke="currentColor" 
                    strokeWidth="2" 
                    strokeLinecap="round" 
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
              <div className="faq-answer">
                <div className="faq-answer-content">
                  <p>{faq.answer}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="faq-cta">
          <p>Still have questions?</p>
          <a href="#contact" className="btn-primary-new">
            Contact Us
            <svg width="18" height="18" viewBox="0 0 20 20" fill="none">
              <path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </a>
        </div>
      </div>
    </section>
  );
};

export default FAQ;




